import {Controller} from "stimulus"
import AutoNumeric from "autonumeric";
import {cartIdFromPage, withValidCart} from "./cart_validity";
import {holdCardLine, releaseCardLine} from "./card_intent";

let autoNumericList = [];

let paymentButton, stripe, card, terminal, selectedReader, paymentIntentId

export default class extends Controller {

    connect(e) {

        console.log("log from cr-cc-terminal controller");
        paymentButton = this.element.querySelector('.card-detail-button')
        paymentButton.disabled = true;
        paymentButton.innerText = 'Connecting to Reader'
        autoNumericList = new AutoNumeric.multiple([".surcharge-display", ".total-charge"], ['NorthAmerican', {unformatOnSubmit: true}]);
        terminal = StripeTerminal.create({
            onFetchConnectionToken: fetchConnectionToken,
            onUnexpectedReaderDisconnect: unexpectedDisconnect
        })
        updateCharges(this.element);
        discoverReaders()

    }

    connectReader(e) {
        e.preventDefault();
        e.target.disabled = true;
        e.target.innerText = "Activating..."
        paymentButton = this.element.querySelector('.terminal-connect-button')
        // Confirm the cart is still checkout-able before activating the reader
        withValidCart(cartIdFromPage(), function () {
            terminal.connectReader(selectedReader).then(function (connectResult) {
                if (connectResult.error) {
                    console.log('connectReader Failed to connect: ', connectResult.error);
                } else {
                    console.log('connectReader Connected to reader: ', connectResult.reader.label);
                    e.target.closest(".cc-manual-fields").querySelector('#terminal-id').value = connectResult.reader.id;
                    e.target.classList.add('hidden');
                    paymentButton.classList.remove('hidden');
                    setCartDescription(e.target)
                }
            });
        });
    }

    sendChargeToTerminal(e) {
        e.preventDefault();

        // Block if CC payment would create change due without sufficient cash
        var balanceEl = document.getElementById("balanceAmount");
        if (balanceEl) {
            var balance = makeNumber(balanceEl.innerText);
            if (balance < 0) {
                var cashInputs = document.querySelectorAll("[data-tender-type='cash']");
                var cashTotal = 0;
                for (var i = 0; i < cashInputs.length; i++) {
                    cashTotal += makeNumber(cashInputs[i].value || "0");
                }
                if (cashTotal < Math.abs(balance)) {
                    alert("Change can only be given from cash payments. Please reduce the credit card amount or add a cash payment to cover the change due.");
                    return;
                }
            }
        }

        const form = e.target.form;

        // Get the CSRF token from the meta tag
        const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

        // The intent the server is about to create is fixed at the total showing
        // now, so the cart is the gateway's from this moment rather than from
        // when the client secret lands, and the amount is frozen for the whole
        // window. Handed back if nothing is created: a stale cart is refused
        // before the request goes, and a request that fails leaves no intent
        // behind it.
        const committedFields = e.target.closest(".cc-manual-fields");
        holdCardLine(committedFields);

        // Confirm the cart is still checkout-able before requesting a charge
        withValidCart(cartIdFromPage(), function () {
            // Built here rather than before the check: whatever the form carries
            // when the request actually goes is what the reader is asked to
            // take, so the page and the gateway cannot disagree about it.
            const formData = new FormData(form);
            // Submit the form using Fetch API
            fetch(form.action, {
                method: form.method,
                body: formData,
                headers: {
                    'X-CSRF-Token': csrfToken,
                    'Accept': 'application/json',
                },
                credentials: 'same-origin',
            })
                .then(response => {
                    if (!response.ok) {
                        return response.json().then(data => {
                            throw new Error(data.errors || 'Unknown error occurred');
                        });
                    }
                    return response.json();
                })
                .then(data => {
                    console.log("update charge form post-creation");
                    document.querySelector(".stripe-payment-form-area").innerHTML = data.html;
                    document.querySelector(".card-detail-button").classList.add('hidden');
                    document.querySelector(".terminal-connect-button").classList.add('hidden');
                    e.target.closest(".cc-manual-fields").querySelector("#cash_receipting_cc_terminal_payment_amount_tendered").disabled = true;
                    stripe = Stripe(e.target.closest(".cc-manual-fields").querySelector("#stripe-api-key").value);
                    var elements = stripe.elements();
                    var style = {
                        base: {
                            color: "#32325d",
                            fontFamily: 'Poppins, sans-serif',
                            fontSize: '24px',
                            backgroundColor: '#f7fbfd'
                        }
                    };
                    console.log("sendChargeToTerminal get payment_intent from from backend");
                    const client_secret = e.target.closest(".cc-manual-fields").querySelector("#stripe-key").value;
                    const resultsArea = e.target.closest(".cc-manual-fields").querySelector(".stripe-result");
                    const ccFields = e.target.closest(".cc-manual-fields");
                    e.target.closest(".cc-manual-fields").querySelector("#stripe-submit").classList.add('hidden');
                    collectAndProcessPayment(client_secret, resultsArea, ccFields);
                })
                .catch(error => {
                    releaseCardLine(committedFields);
                    console.error('Error during form submission:', error);
                    alert('Failed to set card payment. Please try again.');
                });
        }, function () {
            releaseCardLine(committedFields);
        });

    }


    updateChargeAmount(e) {
        updateCharges(e.target)
    }

}

function makeNumber(textVal) {
    return Number(textVal.replace(/[$,]/g, "").trim());
}

export function currencyToCents(textVal) {
    const amount = Number(String(textVal || "").replace(/[$,\s]/g, ""));
    if (Number.isNaN(amount)) {
        return 0;
    }

    return Math.round((amount + Number.EPSILON) * 100);
}

function fetchConnectionToken() {
    return fetch('/stripe_terminals/connection_token', {method: "GET"})
        .then(function (response) {
            return response.json();
        })
        .then(function (data) {
            return data.secret;
        });
}

function discoverReaders() {
    const preferredReader = document.getElementById('cc_machine')
    const config = {simulated: false}
    const creditCardFields = document.querySelector(".cc-manual-fields")
    const resultsArea = creditCardFields.querySelector(".stripe-result");

    let readers
    terminal.discoverReaders(config)
        .then(function (discoverResult) {
            if (discoverResult.error) {
                console.log('Failed to discover: ', discoverResult.error);
            } else if (discoverResult.discoveredReaders.length === 0) {
                console.log('No available readers.', discoverResult);
                setResultMessage(resultsArea, 'No available readers; please choose a different payment method.', 'alert');
            } else {
                // You should show the list of discoveredReaders to the
                // cashier here and let them select which to connect to (see below).
                console.log('168', discoverResult)
                readers = discoverResult.discoveredReaders.filter(function (terminal) {
                    return preferredReader.value === terminal.id
                })
                console.log('172', readers)
            if (readers.length > 0) {
                selectedReader = readers[0];
                paymentButton.disabled = false;
                paymentButton.innerText = 'Activate Reader'
            }
        }
    });
}

function unexpectedDisconnect() {
    // In this function, your app should notify the user that the reader disconnected.
    // You can also include a way to attempt to reconnect to a reader.
    console.log("Disconnected from reader")
}

function setCartDescription(target) {
    const cartId = location.pathname.match(/\d{1,30}/);
    const amountTendered = currencyToCents(target.closest(".cc-manual-fields").querySelector("#cash_receipting_cc_terminal_payment_amount_tendered").value);
    const amountSurcharge = currencyToCents(target.closest(".cc-manual-fields").querySelector("#cash_receipting_cc_terminal_payment_surcharge_amount").value);
    fetch('/carts/' + cartId, {method: "GET"})
        .then(function (response) {
            return response.json();
        })
        .then(function (data) {
            let cartInfo = Object.assign({}, data);
            cartInfo.cart.total = amountTendered + amountSurcharge;
            cartInfo.cart.line_items.push({description: "Today's Payment:", amount: amountTendered, quantity: 1});
            cartInfo.cart.line_items.push({description: "CC Surcharge:", amount: amountSurcharge, quantity: 1});
            console.log("setCartDescription cartInfo", cartInfo);
            terminal.setReaderDisplay(cartInfo)
        });
}

var CARD_DECLINE_CODES = [
    'card_declined', 'expired_card', 'incorrect_cvc', 'processing_error',
    'insufficient_funds', 'restricted_card', 'lost_card', 'stolen_card'
];
var MAX_RETRIES = 3;

function isCardDeclineError(error) {
    return error && error.code && CARD_DECLINE_CODES.indexOf(error.code) !== -1;
}

function setResultMessage(resultsArea, message, cssClass) {
    resultsArea.textContent = '';
    var p = document.createElement('p');
    p.className = cssClass;
    p.textContent = message;
    resultsArea.appendChild(p);
}

function collectAndProcessPayment(clientSecret, resultsArea, ccFields, retriesLeft) {
    if (retriesLeft === undefined) { retriesLeft = MAX_RETRIES; }
    setResultMessage(resultsArea, 'Waiting for card...', 'notice');
    terminal.collectPaymentMethod(clientSecret).then(function (collectResult) {
        if (collectResult.error) {
            console.log('sendChargeToTerminal collectPaymentMethod error', collectResult.error);
            setResultMessage(resultsArea, collectResult.error.message, 'alert');
            enableReprocessButton(ccFields, 'Retry Payment');
            return;
        }
        console.log('sendChargeToTerminal terminal.collectPaymentMethod:', collectResult.paymentIntent);
        terminal.processPayment(collectResult.paymentIntent).then(function (processResult) {
            if (processResult.error) {
                console.log('sendChargeToTerminal payment error:', processResult.error);
                if (isCardDeclineError(processResult.error) && retriesLeft > 0) {
                    setResultMessage(resultsArea, processResult.error.message + ' — Please try another card.', 'alert');
                    collectAndProcessPayment(clientSecret, resultsArea, ccFields, retriesLeft - 1);
                } else {
                    setResultMessage(resultsArea, processResult.error.message, 'alert');
                    enableReprocessButton(ccFields, 'Retry Payment');
                }
            } else if (processResult.paymentIntent) {
                paymentIntentId = processResult.paymentIntent.id;
                console.log('sendChargeToTerminal terminal.processPayment', processResult.paymentIntent);
                if (processResult.paymentIntent.status === 'requires_capture') {
                    captureTerminalPayment(paymentIntentId, processResult, resultsArea, ccFields);
                } else {
                    setResultMessage(resultsArea, 'Unexpected payment status: ' + processResult.paymentIntent.status, 'alert');
                }
            }
        });
    });
}

function captureTerminalPayment(intentId, processResult, resultsArea, ccFields) {
    var csrfToken = document.querySelector('meta[name="csrf-token"]');
    var headers = {'Content-Type': 'application/json'};
    if (csrfToken) { headers['X-CSRF-Token'] = csrfToken.content; }

    fetch('/cash_receipting/cc_terminal_payments/capture_payment', {
        method: "POST",
        headers: headers,
        credentials: 'same-origin',
        body: JSON.stringify({"id": intentId})
    })
        .then(function (response) {
            if (!response.ok) {
                return response.json().then(function (errData) {
                    throw new Error(errData.error || "Payment capture failed");
                });
            }
            return response.json();
        })
        .then(function (data) {
            console.log('sendChargeToTerminal payment captured', data);
            ccFields.querySelector(".terminal-connect-button").classList.add('hidden');
            setResultMessage(resultsArea, 'Payment Successful', 'notice');
            ccFields.querySelector(".stripe-payment-form-area").classList.add('hidden');
            ccFields.querySelector(".ready-to-pay").innerText = "true";
            ccFields.querySelector("#cash_receipting_cc_terminal_payment_reference").value = processResult.paymentIntent.id;
            ccFields.querySelector("#cash_receipting_cc_terminal_payment_amount_tendered").disabled = true;
            ccFields.closest(".payment-line").querySelector(".button--dropdown").disabled = true;
        })
        .catch(function (error) {
            console.log('sendChargeToTerminal capture error:', error);
            setResultMessage(resultsArea, error.message, 'alert');
            enableReprocessButton(ccFields, 'Reprocess');
        });
}

function enableReprocessButton(ccFields, label) {
    var btn = ccFields.querySelector(".terminal-connect-button");
    if (btn) {
        btn.disabled = false;
        btn.innerText = label;
        btn.classList.remove('hidden');
    }
}

function updateCharges(line) {
    console.log("Charge Amount updated, updating surcharge");
    const surchargeDisplay = line.closest(".cc-manual-fields").querySelector(".surcharge-display");
    const totalDisplay = line.closest(".cc-manual-fields").querySelector(".total-charge");
    const base = makeNumber(line.closest(".cc-manual-fields").querySelector("#cash_receipting_cc_terminal_payment_surcharge_base").value);
    const rate = makeNumber(line.closest(".cc-manual-fields").querySelector("#cash_receipting_cc_terminal_payment_surcharge_rate").value);
    const newAmountTendered = makeNumber(line.closest(".cc-manual-fields").querySelector("#cash_receipting_cc_terminal_payment_amount_tendered").value);
    const newSurcharge = Math.round((newAmountTendered * (rate) + base) * 100) / 100;
    const newTotal = Math.round((newAmountTendered * (1 + rate) + base) * 100) / 100;
    line.closest(".cc-manual-fields").querySelector("#cash_receipting_cc_terminal_payment_surcharge_amount").value = newSurcharge;
    surchargeDisplay.innerText = newSurcharge;
    totalDisplay.innerText = newTotal;
    autoNumericList.reformat;
}
